(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('purchaseOrders', purchaseOrders);

    function purchaseOrders(lodash) {
        return {
            retrict: 'E',
            scope: {
                options: '=?',
            },
            templateUrl: 'common/app/components/billing/purchase-orders',
            controller: purchaseOrdersCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, iElement, iAttrs, ngModelCtrl) {

            },
        };

        function purchaseOrdersCtrl($scope, GenericModel) {
            var vm = this;

            // functions
            this.$onInit = function() {
                vm.handlePendingPayments = handlePendingPayments;

                // init
                vm.purchaseOrders = [];

                init();
            }
            function init() {
                callRemoteApi(lodash.get(vm, 'options.datasource.pending_payments_entity', {}), { entity: vm.selectedPendingPaymentsEntity })
                    .then(function (res) {
                        vm.purchaseOrders = res || [];
                    });
            }

            function handlePendingPayments(singlePendingPaymentEntity) {
                var pendingPaymentsButton = lodash.get(vm, 'options.row_item_buttons.pending_payments', {});
                var event = lodash.get(pendingPaymentsButton, 'event.click', '');

                $scope.$emit(event, singlePendingPaymentEntity);
            }

            function callRemoteApi(datasource, postData) {
                var model = new GenericModel(datasource.url);
                var method = lodash.get(datasource, 'method', 'get');

                var queries = postData;
                var params = {};

                if (method !== 'get') {
                    queries = {};
                    params = {
                        data: postData,
                    }
                }

                return model[method](queries, params).$promise.then(function(res) { //res
                    if (res.success && res.status_code == 200) {

                        return lodash.get(res, 'rows', []);
                    } else {
                        console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                        return null;
                    }
                }, function(err) {
                    console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    console.warn(err); // eslint-disable-line no-console
                    return null;
                });
            }
        }
    }
})();